/**
 * Blog listing — intro expand and load-more pagination.
 */
(function () {
  var section = document.querySelector("[data-blog-section]");
  if (!section) return;

  var grid = section.querySelector("[data-blog-grid]");
  var loadMoreBtn = section.querySelector("[data-blog-load-more]");
  var sectionId = section.getAttribute("data-section-id");

  function initIntro() {
    var intro = section.querySelector("[data-blog-intro]");
    if (!intro) return;

    var truncateChars = parseInt(intro.getAttribute("data-truncate-chars"), 10) || 200;
    var fullEl = intro.querySelector("[data-blog-intro-full]");
    if (!fullEl) return;

    var fullText = fullEl.textContent.trim();
    if (fullText.length <= truncateChars) return;

    var truncated = fullText.slice(0, truncateChars).trim();
    var lastSpace = truncated.lastIndexOf(" ");
    if (lastSpace > truncateChars * 0.7) {
      truncated = truncated.slice(0, lastSpace);
    }

    fullEl.textContent = truncated + "\u2026";

    var moreBtn = document.createElement("button");
    moreBtn.type = "button";
    moreBtn.className = "blog__intro-more";
    moreBtn.textContent = intro.getAttribute("data-more-label") || "More";
    fullEl.parentNode.appendChild(moreBtn);

    moreBtn.addEventListener("click", function () {
      fullEl.textContent = fullText;
      moreBtn.remove();
    });
  }

  function initLoadMore() {
    if (!loadMoreBtn || !grid || !sectionId) return;

    loadMoreBtn.setAttribute("data-default-text", loadMoreBtn.textContent);
    loadMoreBtn.setAttribute("data-loading-text", "Loading\u2026");

    loadMoreBtn.addEventListener("click", function () {
      var nextUrl = loadMoreBtn.getAttribute("data-next-url");
      if (!nextUrl) return;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = loadMoreBtn.getAttribute("data-loading-text");

      var fetchUrl =
        nextUrl.indexOf("?") >= 0
          ? nextUrl + "&section_id=" + encodeURIComponent(sectionId)
          : nextUrl + "?section_id=" + encodeURIComponent(sectionId);

      fetch(fetchUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newSection = doc.querySelector("[data-blog-section]");
          if (!newSection) return;

          var newGrid = newSection.querySelector("[data-blog-grid]");
          var newLoadMore = newSection.querySelector("[data-blog-load-more]");
          if (newGrid) {
            newGrid.querySelectorAll("[data-blog-card]").forEach(function (card) {
              grid.appendChild(card);
            });
          }

          if (newLoadMore) {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = loadMoreBtn.getAttribute("data-default-text");
            loadMoreBtn.setAttribute("data-next-url", newLoadMore.getAttribute("data-next-url") || "");
          } else {
            var wrap = loadMoreBtn.closest(".blog__load-more");
            if (wrap) wrap.remove();
          }
        })
        .catch(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = loadMoreBtn.getAttribute("data-default-text");
          window.location.href = nextUrl;
        });
    });
  }

  initIntro();
  initLoadMore();
})();
